import { render, staticRenderFns } from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiList.vue?vue&type=template&id=f5b067f6"
import script from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiList.vue?vue&type=script&lang=js"
export * from "./AdiPaiPrestazioniResidenzialiSemiResidenzialiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports